// Auto generated file, do not manually modify!
// com.hotpads.clientappconfig.web.handler.web.ClientAppConfigWebHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  ClientAppConfigWebHandler_getAllFeatures,
  ClientAppConfigWebHandler_getAllFeatures_Path,
  ClientAppConfigWebHandler_getFeature,
  ClientAppConfigWebHandler_getFeature_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

interface GetAllFeaturesParams {
  appName: string;
}
interface GetFeatureParams {
  appName: string;
  featureName: string;
}

export type ClientAppConfigWebHandler_getAllFeatures_Options = UseQueryOptions<
  Record<string, string>,
  unknown,
  Record<string, string>,
  readonly [string, GetAllFeaturesParams]
>;

const ClientAppConfigWebHandler_getAllFeatures_GetKey = (getParams: GetAllFeaturesParams) =>
  [ClientAppConfigWebHandler_getAllFeatures_Path, getParams] as const;

export const ClientAppConfigWebHandler_getAllFeatures_queryOptions = (getParams: GetAllFeaturesParams) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: ClientAppConfigWebHandler_getAllFeatures_GetKey(getParams),
    queryFn: () => ClientAppConfigWebHandler_getAllFeatures(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get all app configuration for an application
 */
export const useClientAppConfigWebHandler_getAllFeatures = (
  getParams: GetAllFeaturesParams,
  options: Omit<ClientAppConfigWebHandler_getAllFeatures_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...ClientAppConfigWebHandler_getAllFeatures_queryOptions(getParams),
    ...options,
  });
};
useClientAppConfigWebHandler_getAllFeatures.getKey = ClientAppConfigWebHandler_getAllFeatures_GetKey;

export type ClientAppConfigWebHandler_getFeature_Options = UseQueryOptions<
  string,
  unknown,
  string,
  readonly [string, GetFeatureParams]
>;

const ClientAppConfigWebHandler_getFeature_GetKey = (getParams: GetFeatureParams) =>
  [ClientAppConfigWebHandler_getFeature_Path, getParams] as const;

export const ClientAppConfigWebHandler_getFeature_queryOptions = (getParams: GetFeatureParams) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: ClientAppConfigWebHandler_getFeature_GetKey(getParams),
    queryFn: () => ClientAppConfigWebHandler_getFeature(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get app configuration feature for an application
 */
export const useClientAppConfigWebHandler_getFeature = (
  getParams: GetFeatureParams,
  options: Omit<ClientAppConfigWebHandler_getFeature_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...ClientAppConfigWebHandler_getFeature_queryOptions(getParams),
    ...options,
  });
};
useClientAppConfigWebHandler_getFeature.getKey = ClientAppConfigWebHandler_getFeature_GetKey;
